import { register } from "@shared/services/propertyRendererRegistry";
import StatusTagRenderer from "@shared/components/tickets/components/StatusTagRenderer.vue";
import StatusSelectEditor from "@shared/components/tickets/components/StatusSelectEditor.vue";
import ProductRelationRenderer from "./components/ProductRelationRenderer.vue";
import { ticketType } from "./constants";

register({
  twinTypePattern: ticketType,
  customId: "status",
  viewComponentTable: StatusTagRenderer,
  viewComponentDetail: StatusTagRenderer,
  editComponent: StatusSelectEditor,
});

register({
  twinTypePattern: ticketType,
  customId: "product",
  viewComponentDetail: ProductRelationRenderer,
});
